import Container from "shared/ui/container";
import PaymentProvider from "./providers/PaymentProvider";
import Partials from "./partials";

const Payment = () => {
  return (
    <PaymentProvider>
      <main>
        <Container>
          <Partials />
        </Container>
      </main>
    </PaymentProvider>
  );
};
export default Payment;
